module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_13.e8158ceb.jpg";